import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { fontFamilies } from '../theme/text';

interface DataGridTextCellProps {
  value: string | number;
}

const useStyles = makeStyles({
  cellText: {
    margin: 0,
    fontFamily: fontFamilies.heading,
    fontSize: 16
  }
});

const DataGridTextCell = ({ value }: DataGridTextCellProps) => {
  const classes = useStyles();
  return (
    <div>
      <p className={classes.cellText}>{value}</p>
    </div>
  );
};

export default DataGridTextCell;
